import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { HashLink } from "react-router-hash-link";
import { db } from "../firebase"; // firebase config file
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

const capitalizeWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

const Careers = () => {
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationData, setApplicationData] = useState({
    name: "",
    email: "",
    phone: "",
    workExperience: "",
    coverLetter: "",
    resume: null,
  });
  const [appSuccessMessage, setAppSuccessMessage] = useState("");
  const [contactSuccessMessage, setContactSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [Jobs, setJobs] = useState([]); // <- Firebase Jobs
  const [resumeError, setResumeError] = useState("");


  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const q = query(collection(db, "Jobs"), orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(q);
        const JobsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setJobs(JobsData);
      } catch (error) {
        console.error("Error fetching Jobs:", error);
      }
    };

    fetchJobs();
  }, []);

  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);

  const handleSubmitApplication = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // 1️⃣ Send email & upload to backend
      const formData = new FormData();
      formData.append("jobTitle", selectedJob?.title);
      formData.append("name", applicationData.name);
      formData.append("email", applicationData.email);
      formData.append("phone", applicationData.phone);
      formData.append("workExperience", applicationData.workExperience);
      formData.append("coverLetter", applicationData.coverLetter);
      if (applicationData.resume) {
        formData.append("resume", applicationData.resume);
      }

      const res = await fetch(
        "https://vpjc-api-805872224468.asia-south1.run.app/api/application/submit",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json(); // <-- backend response, includes resume_url

      // 2️⃣ Save to Firestore Applications collection
      await addDoc(collection(db, "Applications"), {
        jobId: selectedJob?.id,
        jobTitle: selectedJob?.title,
        name: applicationData.name,
        email: applicationData.email,
        phone: applicationData.phone,
        workExperience: applicationData.workExperience,
        coverLetter: applicationData.coverLetter,
        resumeName: applicationData.resume?.name || "",
        resumeUrl: data.data.resume_url || "", // now this works
        appliedAt: new Date(),
      });

      setAppSuccessMessage(
        "✅ Application submitted & email sent successfully!"
      );

      // Reset form
      setApplicationData({
        name: "",
        email: "",
        phone: "",
        workExperience: "",
        coverLetter: "",
        resume: null,
      });

      setTimeout(() => {
        setAppSuccessMessage("");
        setShowApplicationForm(false);
      }, 2500);
    } catch (error) {
      console.error("Error submitting application:", error);
      setAppSuccessMessage(
        "❌ Failed to submit application. Please try again."
      );
    }

    setIsSubmitting(false);
  };

  console.log("Fetched Jobs:", Jobs);
  const handleSubmitContact = async (e) => {
    e.preventDefault();
    setIsContactSubmitting(true);

    try {
      // Save to Firebase
      const timestamp = new Date();
      await addDoc(collection(db, "ContactUs"), {
        name: contactData.name,
        email: contactData.email,
        message: contactData.message,
        createdAt: timestamp, // changed here
      });

      // Prepare backend payload
      const payload = {
        name: contactData.name,
        email: contactData.email,
        message: contactData.message,
        createdAt: timestamp.toISOString(), // send ISO string
      };

      // Send email via backend
      const res = await fetch(
        "https://vpjc-api-805872224468.asia-south1.run.app/api/contact/send",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Email sending failed");

      setContactSuccessMessage("✅ Your message has been sent successfully!");
      setContactData({ name: "", email: "", message: "" });

      setTimeout(() => setContactSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Contact submission error:", error);
      setContactSuccessMessage("❌ Failed to send message. Please try again.");
    }

    setIsContactSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-white transition-all duration-500">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#204080] to-[#2E5AAC] text-white py-20 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white drop-shadow-sm mb-4 tracking-tight leading-snug font-serif text-center">
  Work with <br /> Visakha Physiotherapy & Jasti Chiropractic
</h1>


          <p className="text-lg max-w-2xl mx-auto text-white opacity-90">
            Join our team of expert physiotherapists and grow your career with
            us.
          </p>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#204080] to-[#3a5bb8] drop-shadow-sm mb-4 tracking-tight leading-snug font-serif">
  Why Work With Us?
</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-[#204080] mb-2">
                Our Mission
              </h3>
              <p className="text-gray-600 font-sans leading-relaxed">
                To provide world-class services and care.
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-[#204080] mb-2">
                Our Values
              </h3>
              <p className="text-gray-600">
                Integrity, Compassion, and Teamwork.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Job Openings */}
      <section className="py-16 px-6 bg-gradient-to-br from-blue-50 to-slate-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-extrabold font-serif text-center text-[#204080] mb-8">
  Current Job Openings
</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {Jobs.map((job) => (
              <div
                key={job.id}
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
              >
                <h3 className="text-2xl font-bold text-[#204080] mb-2">
                  {job.title}
                </h3>
                <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mb-4">
                  <div className="font-medium">Location:</div>
                  <div>{job.location}</div>
                  <div className="font-medium">Work Experience:</div>
                  <div>{job.workExperience}</div>
                  <div className="font-medium">Openings:</div>
                  <div>{job.openings}</div>
                  <div className="font-medium">Work Pattern:</div>
                  <div>{job.workPattern}</div>
                </div>
                <button
                  onClick={() => {
                    setSelectedJob(job);
                    setShowApplicationForm(true);
                  }}
                  className="bg-[#204080] text-white px-6 py-2 rounded-lg hover:bg-[#2E5AAC] transition-transform duration-300 hover:scale-105"
                >
                  Apply Now
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Life at Visakha */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold font-serif text-center text-[#204080] mb-8">
  Life at Visakha
</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-md">
              <p className="text-gray-600 italic">
                "Working here has been a dream. The team supports each other,
                and the patients are grateful."
              </p>
              <p className="font-bold text-[#204080] mt-2">
                Dr. Balaga Damodara Rao
              </p>
              <p className="text-gray-500">Physiotherapy</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-md">
              <p className="text-gray-600 italic">
                "I love the balance between work and personal life."
              </p>
              <p className="font-bold text-[#204080] mt-2">
                Dr. Sala Hari Priya
              </p>
              <p className="text-gray-500">Physiotherapy</p>
            </div>
          </div>
        </div>
      </section>

      {/* Perks & Benefits */}
      <section className="py-16 px-6 bg-gradient-to-br from-blue-50 to-slate-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-[#204080] mb-8 font-serif">
            Perks & Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-[#204080] mb-2">
                Health & Wellness
              </h3>
              <p className="text-gray-600">
                Comprehensive insurance and wellness programs.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-[#204080] mb-2">
                Work-Life Balance
              </h3>
              <p className="text-gray-600">
                Flexible hours and remote options.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-[#204080] mb-2">
                Professional Growth
              </h3>
              <p className="text-gray-600">
                Leadership development and training.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Diversity & Inclusion */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-[#204080] mb-8 font-serif">
            Diversity & Inclusion
          </h2>
          <div className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-md">
            <p className="text-gray-600">
              We foster inclusion for all. Here’s how:
            </p>
            <ul className="mt-4 text-gray-600 space-y-2 list-disc list-inside">
              <li>
                <strong>Equal Opportunity:</strong> Fair hiring for all.
              </li>
              <li>
                <strong>Training:</strong> Mandatory programs on inclusion.
              </li>
              <li>
                <strong>ERGs:</strong> Support for cultural and diversity
                groups.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Application Process */}
      <section className="py-16 px-6 bg-gradient-to-br from-blue-50 to-slate-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-[#204080] mb-8 font-serif">
            Application Process
          </h2>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold text-[#204080] mb-4">Timeline</h3>
            <ol className="list-decimal text-gray-700 space-y-2 pl-5">
              <li>
                <strong>Initial Screening:</strong> Within 5 business days.
              </li>
              <li>
                <strong>HR Review:</strong> Qualified candidates are assessed
                next.
              </li>
              <li>
                <strong>Interviews:</strong> 1–2 rounds (phone/video/in-person).
              </li>
              <li>
                <strong>Offer:</strong> Within 5 business days of final
                interview.
              </li>
            </ol>
          </div>
        </div>
      </section>

      {/* Career Pathways */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-[#204080] mb-8 font-serif">
            Career Pathways
          </h2>
          <div className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-md">
            <p className="text-gray-700 mb-4">
              Grow with structured training and clear professional paths.
            </p>
            <h3 className="text-xl font-bold text-[#204080] mb-2">
              Physiotherapy Track
            </h3>
            <ol className="list-decimal text-gray-700 space-y-2 pl-5">
              <li>
                <strong>Junior:</strong> Entry-level with mentorship.
              </li>
              <li>
                <strong>Senior:</strong> Leadership in care and specialization.
              </li>
              <li>
                <strong>Lead:</strong> Staff supervision and policy development.
              </li>
            </ol>
          </div>
        </div>
      </section>

      {/* Contact Us */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-[#204080] mb-8 font-serif">
            Contact Us
          </h2>

          <form
            onSubmit={handleSubmitContact}
            className="bg-gradient-to-br from-blue-50 to-slate-50 p-6 rounded-lg shadow-md"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">
                  Full Name
                </label>
                <input
  type="text"
  placeholder="Enter your name"
  value={applicationData.name}
  onChange={(e) =>
    setApplicationData({
      ...applicationData,
      name: e.target.value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
    })
  }
  required
  pattern="[A-Za-z\s]+"
  onInvalid={(e) =>
    e.target.setCustomValidity(
      "Please enter your name."
    )
  }
  onInput={(e) => e.target.setCustomValidity("")} // clears message
  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm px-4 py-3"
/>



              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700">
                  Email
                </label>

                <input
                  type="email"
                  placeholder="Enter your email"
                  value={contactData.email}
                  onChange={(e) =>
                    setContactData({ ...contactData, email: e.target.value })
                  }
                  required
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm px-4 py-3"
                />
              </div>
            </div>

            <div className="mt-6 space-y-2">
              <label className="text-sm font-medium text-gray-700">
                Message
              </label>
              <textarea
                rows="4"
                placeholder="Enter your message"
                value={contactData.message}
                onChange={(e) =>
                  setContactData({ ...contactData, message: e.target.value })
                }
                required
                className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm p-2"
              ></textarea>
            </div>

            {contactSuccessMessage && (
              <div className="mt-4 p-3 bg-green-100 text-green-800 rounded-lg">
                {contactSuccessMessage}
              </div>
            )}

            <div className="flex justify-end mt-6">
              <button
                type="submit"
                disabled={isContactSubmitting}
                className={`bg-[#204080] text-white px-6 py-3 rounded-lg hover:bg-[#2E5AAC] transition-transform duration-300 ${
                  isContactSubmitting
                    ? "cursor-not-allowed bg-gray-300 text-gray-600"
                    : ""
                }`}
              >
                {isContactSubmitting ? (
                  <div className="flex items-center justify-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      />
                    </svg>
                    <span>Sending...</span>
                  </div>
                ) : (
                  "Send Message"
                )}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Application Modal */}
      {showApplicationForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-screen overflow-y-auto p-6 relative">
  {/* Modal Header */}
  <div className="flex justify-between items-center mb-4 bg-white pb-2">

    <h2 className="text-2xl font-bold text-[#204080]">
      Apply for {selectedJob?.title}
    </h2>
    <button
      onClick={() => setShowApplicationForm(false)}
      className="text-gray-500 hover:text-gray-700"
    >
      ✖
    </button>
  </div>

            {/* Form */}
            <form onSubmit={handleSubmitApplication} className="space-y-4 p-6">
              <div>
  <label className="block text-sm font-medium text-gray-700">
    Job Title
  </label>
  <input
    type="text"
    value={selectedJob?.title}
    readOnly
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm 
               focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none 
               sm:text-sm px-4 py-3"
  />
</div>


              <div>
  <label className="block text-sm font-medium text-gray-700">
    Your Name
  </label>
  <input
    type="text"
    placeholder="Enter your name"
    value={applicationData.name}
    onChange={(e) =>
      setApplicationData({
        ...applicationData,
        name: e.target.value
          .replace(/[^a-zA-Z\s]/g, "") // Only letters & spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()), // Capitalize first letter of each word
      })
    }
    required
    pattern="[A-Za-z\s]+"
    onInvalid={(e) =>
      e.target.setCustomValidity("Please enter your name using letters only.")
    }
    onInput={(e) => e.target.setCustomValidity("")}
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm px-4 py-3"
  />
</div>

<div>
  <label className="block text-sm font-medium text-gray-700">
    Email Address
  </label>
  <input
    type="email"
    placeholder="Enter your email"
    value={applicationData.email}
    onChange={(e) =>
      setApplicationData({
        ...applicationData,
        email: e.target.value,
      })
    }
    required
    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
    onInvalid={(e) =>
      e.target.setCustomValidity("Please enter a valid email address.")
    }
    onInput={(e) => e.target.setCustomValidity("")}
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm px-4 py-3"
  />
</div>

<div>
  <label className="block text-sm font-medium text-gray-700">
    Phone Number
  </label>
  <input
    type="tel"
    placeholder="Enter your phone number"
    value={applicationData.phone}
    onChange={(e) =>
      setApplicationData({
        ...applicationData,
        phone: e.target.value.replace(/\D/g, ""), // allow only digits
      })
    }
    required
    pattern="[0-9]{10}" // validation: exactly 10 digits
    maxLength={10} // restrict typing beyond 10
    onInvalid={(e) =>
      e.target.setCustomValidity("Please enter a valid 10-digit phone number.")
    }
    onInput={(e) => e.target.setCustomValidity("")}
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm px-4 py-3"
  />
</div>

<div>
  <label className="block text-sm font-medium text-gray-700">
    Work Experience <span className="text-red-500">*</span>
  </label>
  <select
    value={applicationData.workExperience}
    onChange={(e) =>
      setApplicationData({
        ...applicationData,
        workExperience: e.target.value,
      })
    }
    required
    onInvalid={(e) =>
      e.target.setCustomValidity("Please select your work experience.")
    }
    onInput={(e) => e.target.setCustomValidity("")}
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[rgb(32,64,128)] focus:ring-0 focus:outline-none sm:text-sm px-4 py-3"
  >
    <option value="">Select Experience</option>
    <option value="0-1 yrs">0-1 yrs</option>
    <option value="2-3 yrs">2-3 yrs</option>
    <option value="4-5 yrs">4-5 yrs</option>
    <option value="5+ yrs">5+ yrs</option>
  </select>
</div>

<div>
  <label className="block text-sm font-medium text-gray-700">
    Cover Letter
  </label>
  <textarea
    rows="4"
    value={applicationData.coverLetter}
    onChange={(e) =>
      setApplicationData({
        ...applicationData,
        coverLetter: e.target.value,
      })
    }
    onInvalid={(e) =>
      e.target.setCustomValidity("Please enter your cover letter.")
    }
    onInput={(e) => e.target.setCustomValidity("")}
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm"
  ></textarea>
</div>

<div>
  <label className="block text-sm font-medium text-gray-700">
    Resume
  </label>
  <input
    type="file"
    accept=".pdf,.doc,.docx"
    onChange={(e) => {
      const file = e.target.files[0];
      if (!file) return;

      const validTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ];

      if (!validTypes.includes(file.type)) {
        setResumeError("❌ Invalid file type. Please upload PDF or DOC/DOCX only.");
        e.target.value = null;
        setApplicationData({ ...applicationData, resume: null });
        return;
      }

      const maxSize = 2 * 1024 * 1024; // 2MB
      if (file.size > maxSize) {
        setResumeError("❌ File is too large. Max size is 2MB.");
        e.target.value = null;
        setApplicationData({ ...applicationData, resume: null });
        return;
      }

      setResumeError(""); // clear error
      setApplicationData({ ...applicationData, resume: file });
    }}
    required
    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-2 focus:border-[#204080] focus:ring-0 focus:outline-none sm:text-sm"
  />
  {resumeError && (
    <p className="text-sm text-red-600 mt-1">{resumeError}</p>
  )}
  <div className="text-sm text-gray-500 mt-1">
    Max file size: 2MB. Supported formats: PDF, DOC, DOCX.
  </div>
</div>



              {appSuccessMessage && (
                <div className="mt-4 p-3 bg-green-100 text-green-800 rounded-lg text-center">
                  {appSuccessMessage}
                </div>
              )}
              <div className="flex justify-end space-x-4 mt-6">
                <button
                  type="button"
                  onClick={() => setShowApplicationForm(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 shadow-sm text-gray-700 bg-white hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-6 py-2 rounded-md shadow-sm font-semibold transition-all text-white ${
                    isSubmitting
                      ? "bg-gray-300 cursor-not-allowed text-gray-600"
                      : "bg-[#204080] hover:bg-[#2E5AAC]"
                  }`}
                >
                  {isSubmitting ? (
                    <div className="flex items-center justify-center gap-2">
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8z"
                        />
                      </svg>
                      <span>Submitting...</span>
                    </div>
                  ) : (
                    "Submit Application"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Careers;
